import { Injectable } from "@angular/core";

import { map, Observable } from "rxjs";

import { User } from "@shared/models/user.model";
import { BaseHttpService } from "@shared/services/base-http.service";

export type SharePermission = "VIEW" | "EDIT";

export interface DocumentShareModel {
  id: string;
  documentId: string;
  ownerId: string;
  recipientId: string;
  permission: SharePermission;
  createdAt: string;
  updatedAt: string;
}

@Injectable({ providedIn: "root" })
export class DocumentSharingHttpService extends BaseHttpService {
  protected override baseEndpoint = "documents";

  createShare(
    documentId: string,
    recipient: string | null,
    permission: SharePermission,
    shareWithOrganization?: boolean
  ): Observable<DocumentShareModel> {
    return this.post<DocumentShareModel>({
      endpoint: `${documentId}/shares`,
      body: { recipient, permission, shareWithOrganization }
    });
  }

  listShares(documentId: string): Observable<
    {
      share: DocumentShareModel;
      recipient: User | null;
      organization?: { id: string; name: string } | null;
    }[]
  > {
    return this.get<
      Array<{
        share: DocumentShareModel;
        recipient: User | null;
        organization?: { id: string; name: string } | null;
      }>
    >({ endpoint: `${documentId}/shares` }).pipe(
      map((shares) =>
        shares.map((s) => ({
          share: s.share,
          recipient: s.recipient ? new User(s.recipient) : null,
          organization: s.organization ? { id: s.organization.id, name: s.organization.name } : undefined
        }))
      )
    );
  }

  updateShare(shareId: string, permission: SharePermission): Observable<DocumentShareModel> {
    return this.patch<DocumentShareModel>({ endpoint: `shares/${shareId}`, body: { permission } });
  }

  deleteShare(shareId: string): Observable<void> {
    return this.delete<void>({ endpoint: `shares/${shareId}` });
  }
}
